<section class="header__section d__flex align__items--center justify__content--end">
  <ng-content></ng-content>
</section>
